import Analytics from "./Analytics";

// Decides which unhandled promise rejections go to Analytics (PostHog, GA). Sentry's own global
// handler still sees every rejection; this doesn't change what Sentry receives.
const IGNORED_MESSAGES = [
  "ResizeObserver",
  "Failed to fetch dynamically imported module",
  "Loading chunk",
  "Importing a module script failed",
];

export const isIgnoredRejection = (reason) => {
  if (reason == null) return true;
  // A cancelled run is not a failure: SearchCanceled from a stopped search, and AbortError from
  // a fetch aborted on unmount or effect cleanup (PLEX-6664, WEBAPP-G2).
  if (reason?.name === "SearchCanceled" || reason?.name === "AbortError") return true;
  const msg = reason?.message || String(reason);
  return IGNORED_MESSAGES.some(text => msg.includes(text));
};

export const handleUnhandledRejection = (event) => {
  const reason = event.reason;
  if (isIgnoredRejection(reason)) return;
  const msg = reason?.message || String(reason);
  try {
    Analytics.exception(reason instanceof Error ? reason : new Error(msg), false);
  } catch (_) {}
};
